// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__-_20_","contentWithNav":"styles_contentWithNav__1sF-e"};